/**
 * Prophets carousel roster.
 *
 * Fully data-driven: adding a new NFT only requires
 *   (1) dropping the image file under `/frontend/public/img/prophets/`
 *   (2) adding one object to `PROPHETS` (order = display order)
 *       with a `image: "/img/prophets/<filename>"` path.
 * The carousel + pagination + arrows adapt automatically.
 *
 * `INITIAL_ACTIVE_ID` selects the centered card on first paint.
 *
 * Images are served statically from CRA's `public/` folder — no bundling,
 * no imports outside `src/`, and file sizes stay light.
 */

const IMG = "/img/prophets";

export const PROPHETS = [
  {
    id: "zarek-the-harbingers",
    name: "ZAREK",
    family: "THE HARBINGERS",
    image: `${IMG}/zarek-the-harbingers.webp`,
    accent: "#ef334f",
    alt: "Zarek from The Harbingers",
  },
  {
    id: "rhea-the-oracles",
    name: "RHEA",
    family: "THE ORACLES",
    image: `${IMG}/rhea-the-oracles.webp`,
    accent: "#338cff",
    alt: "Rhea from The Oracles",
  },
  {
    id: "knox-the-axioms",
    name: "KNOX",
    family: "THE AXIOMS",
    image: `${IMG}/knox-the-axioms.webp`,
    accent: "#ff7a1a",
    alt: "Knox from The Axioms",
  },
  {
    id: "raze-the-celestials",
    name: "RAZE",
    family: "THE CELESTIALS",
    image: `${IMG}/raze-the-celestials.webp`,
    accent: "#e8edf7",
    alt: "Raze from The Celestials",
  },
  {
    id: "sira-the-singularity",
    name: "SIRA",
    family: "THE SINGULARITY",
    image: `${IMG}/sira-the-singularity.webp`,
    accent: "#d946ef",
    secondaryAccent: "#22d3ee",
    tertiaryAccent: "#f4e94b",
    alt: "Sira from The Singularity",
  },
  {
    id: "vael-the-sovereigns",
    name: "VAEL",
    family: "THE SOVEREIGNS",
    image: `${IMG}/vael-the-sovereigns.webp`,
    accent: "#e7bd58",
    alt: "Vael from The Sovereigns",
  },
  {
    id: "voss-the-obsidian",
    name: "VOSS",
    family: "THE OBSIDIAN",
    image: `${IMG}/voss-the-obsidian.webp`,
    accent: "#8b93a1",
    secondaryAccent: "#8b1e2d",
    alt: "Voss from The Obsidian",
  },
  {
    id: "zayn-the-helix",
    name: "ZAYN",
    family: "THE HELIX",
    image: `${IMG}/zayn-the-helix.webp`,
    accent: "#36d17c",
    alt: "Zayn from The Helix",
  },
  {
    id: "kaela-the-ascendants",
    name: "KAELA",
    family: "THE ASCENDANTS",
    image: `${IMG}/kaela-the-ascendants.webp`,
    accent: "#a855f7",
    secondaryAccent: "#e8edf7",
    alt: "Kaela from The Ascendants",
  },
  {
    id: "sable-the-parallax",
    name: "SABLE",
    family: "THE PARALLAX",
    image: `${IMG}/sable-the-parallax.webp`,
    accent: "#22d3ee",
    secondaryAccent: "#a78bfa",
    alt: "Sable from The Parallax",
  },
];

// Knox opens the carousel as the centered active card.
export const INITIAL_ACTIVE_ID = "knox-the-axioms";
